export default {
  GradeControl: 0, 
  MRMR: 1,
  KPU: 2,
  CashFlow: 3
};
